import React from "react";
import { useSelector, useDispatch } from "react-redux";
import _get from "lodash/get";

import FormFieldsCard from "components/lib/Global/FormFieldsCard";
import CommentsList from "components/lib/Global/CommentsList";
import { addComment, editComment } from "state/slices/comment";
import { Constants } from "config/constants";

export default function RegisteredAddress({ isViewMode, transactions }) {
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.companySlice);
  const { comments } = useSelector((state) => state.commentsSlice);
  const registeredOfficeSlice = useSelector(
    (state) => state.registeredOfficeSlice
  );
  const latestRegisteredOfficeVersion =
    registeredOfficeSlice?.versions &&
      registeredOfficeSlice?.versions?.length > 0
      ? registeredOfficeSlice.versions[
      registeredOfficeSlice?.versions?.length - 2 // we subtract 2 because -1 returns the current data
      ]
      : registeredOfficeSlice;
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  const changeOfRegisteredAddressTransaction = transactions.find(
    (trx) =>
      trx.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_REGISTERED_ADDRESS
  );
  const changeOfRegisteredAddressIndex = transactions.findIndex(
    (trx) => trx._id === changeOfRegisteredAddressTransaction?._id
  );
  const buildUpdateEffectPath = (sliceIndex) =>
    `transactionSlice.transactionUnderReview.items.transactions.${sliceIndex}`;
  const updateEffectKey = "updateTransactionUnderReview";
  const formHelperKey = "initiateTransactionChange";
  const formName = "changeOfRegisteredAddress";

  const changeOfRegisteredAddressUpdateEffectPath = buildUpdateEffectPath(
    changeOfRegisteredAddressIndex
  );
  // comments
  const changeOfRegisteredAddressComments = comments.filter(
    (comment) =>
      comment.transaction === changeOfRegisteredAddressTransaction?._id &&
      comment.formName === formName
  );

  const buildFormFIelds = (sliceName) => {
    return [
      {
        key: "Postal Address",
        name: "postalAddress",
        value: _get(sliceName, "postalAddress") || "N/A",
      },
      {
        key: "Postal Code",
        name: "postalCode",
        value: _get(sliceName, "postalCode") || "N/A",
      },
      {
        key: "Service Address",
        name: "serviceAddress",
        value: _get(sliceName, "serviceAddress") || "N/A",
      },
      {
        key: "Company Email Address",
        name: "companyEmailAddress",
        value: _get(sliceName, "companyEmailAddress") || "N/A",
      },
      {
        key: "Phone Number",
        name: "mobileNumber",
        value: _get(sliceName, "mobileNumber") || "N/A",
      },
      {
        key: "Name of Building",
        name: "buildingName",
        value: _get(sliceName, "buildingName") || "N/A",
      },
      {
        key: "House Number",
        name: "houseNumber",
        value: _get(sliceName, "houseNumber") || "N/A",
      },
      {
        key: "Estate",
        name: "estate",
        value: _get(sliceName, "estate") || "N/A",
      },
      {
        key: "Floor or Suite Number",
        name: "floorNumber",
        value: _get(sliceName, "floorNumber") || "N/A",
      },
      {
        key: "Street Name",
        name: "streetName",
        value: _get(sliceName, "streetName") || "N/A",
      },
      {
        key: "Street Number",
        name: "streetNumber",
        value: _get(sliceName, "streetNumber") || "N/A",
      },
      {
        key: "County",
        name: "location.county",
        value: _get(sliceName, "location.county") || "N/A",
      },
      {
        key: "District",
        name: "location.district",
        value: _get(sliceName, "location.district") || "N/A",
      },
      {
        key: "Locality",
        name: "location.locality",
        value: _get(sliceName, "location.locality") || "N/A",
      },
    ];
  };

  let addressParticularsFormFields = buildFormFIelds(
    latestRegisteredOfficeVersion
  );
  const changedFields = buildFormFIelds(
    changeOfRegisteredAddressTransaction?.companyChangedFields?.registeredOffice
  );

  const handleSaveComment = async (data) => {
    if (data?.commentId) {
      await dispatch(editComment({ commentId: data.commentId, data }));
    } else {
      await dispatch(
        addComment({
          data: {
            ...data,
            company: company._id,
            transaction: changeOfRegisteredAddressTransaction._id,
          },
        })
      );
    }
  };

  return (
    <>
      {changeOfRegisteredAddressComments.length > 0 && (
        <div className="px-8 pt-5 pb-6 mt-4 bg-white">
          <CommentsList
            comments={changeOfRegisteredAddressComments}
            toggleCommentStatus={!isViewMode}
          />
          <p className="mt-6 text-sm text-primary">
            Comments: {changeOfRegisteredAddressComments.length} of{" "}
            {changeOfRegisteredAddressComments.length}
          </p>
        </div>
      )}
      <div className="flex my-10 align-middle">
        <div className="flex items-center form-check">
          <input
            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
            type="checkbox"
            defaultChecked={registeredOfficeSlice?.useSimpleFormationsOffice}
            disabled
            id="flexCheckDefault"
          />
          <label
            className="inline-block form-check-label text-tertiary"
            htmlFor="flexCheckDefault"
          >
            Use Simple Formations office details as your registered business
            address in Kenya.
          </label>
        </div>
      </div>
      <FormFieldsCard
        addReviewComment={!isViewMode}
        formName={formName}
        fields={addressParticularsFormFields}
        resolvedFields={changeOfRegisteredAddressTransaction.resolvedFields}
        formHelperKey={formHelperKey}
        updateEffectKey={updateEffectKey}
        updateEffectPath={changeOfRegisteredAddressUpdateEffectPath}
        formId={_get(changeOfRegisteredAddressTransaction, "_id")}
        handleSaveComment={handleSaveComment}
        comments={changeOfRegisteredAddressComments}
        hideResolveAllCheckbox={!isViewMode}
        changedFields={changedFields}
        changeType={changeOfRegisteredAddressTransaction?.changeType}
        showChangedFields={changedFields.length > 0}
      />
    </>
  );
}
